import { combineReducers } from '@reduxjs/toolkit';

// Example reducer (You'll create actual reducers based on features)
const dummyReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default combineReducers({
  dummy: dummyReducer,
});
